import styled from 'styled-components';
import { FlexColumn } from '@elementary/common-ui/components';
import { Typography } from '@mui/material';
import { fontWeight, radius, space } from '@elementary/common-ui/style/utils';
import SettingsSection from '../SettingsSection';

const PlaceholderBox = styled(FlexColumn)`
  border: 1px dashed ${({ theme }) => theme.palette.border.subtle};
  border-radius: ${radius('md')};
  padding: ${space('xxl')};
  gap: ${space('xs')};
`;

const RuntimeDebugPlaceholder = () => (
  <SettingsSection title="Debugging">
    <PlaceholderBox>
      <Typography sx={{ fontWeight: fontWeight('semibold') }}>
        Coming soon
      </Typography>
      <Typography variant="body1">
        Runtime instances, recent activity, and logs will appear here to help
        you troubleshoot this runtime.
      </Typography>
    </PlaceholderBox>
  </SettingsSection>
);

export default RuntimeDebugPlaceholder;
